<template src='./remittanceIntegrationModal.pug' lang='pug'></template>

<script>
import { VueTabs, VTab } from 'vue-nav-tabs'
import BetterModal from '../../modals/betterModal/BetterModal'
import TabRemittanceDetail from './TabRemittanceDetail'
import TabRemittanceReport from './TabRemittanceReport'
import SituacaoRemessaEnum from '../../../enum/situacaoRemessa'

export default {
  name: 'RemittanceIntegrationModal',

  components: {
    VueTabs,
    VTab,
    BetterModal,
    TabRemittanceDetail,
    TabRemittanceReport
  },

  props: {
    remittance: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    showRemovalButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tabName: null,
      tabs: [],
      modal: {
        text: {
          title: this.$t('remessaIntegracao.remessa.detalhar.modal.titulo'),
          subtitle: this.$t('remessaIntegracao.remessa.detalhar.modal.subtitulo')
        }
      }
    }
  },

  computed: {
    situacaoRemocaoValida () {
      if (this.remittance.Situacao === SituacaoRemessaEnum.CONCLUIDO || this.remittance.Situacao === SituacaoRemessaEnum.ERRO) {
        return false
      }
      return true
    }
  },

  watch: {
    remittance () {
      if (this.remittance.id) {
        this.tabs = []
        this.loadDetail()
      }
    }
  },

  methods: {
    verifyTabAuthorization (tab) {
      return true
    },

    loadDetail () {
      this.tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-TabRemittanceDetail',
        idTabContent: 'tab-detail-id',
        idLanc: this.idRemittance,
        tabRef: 'tabDetailGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabRemittanceDetail',
        props: {
          remittance: this.remittance,
          showRemovalButton: this.showRemovalButton && this.situacaoRemocaoValida
        }
      })
      this.tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-TabRemittanceReport',
        idTabContent: 'tab-report-id',
        idLanc: this.idRemittance,
        tabRef: 'tabReportGridModal',
        title: this.$t('remessaIntegracao.labels.modal.tabs.resumo'),
        icon: 'icon="tab-icon-font fa fa-bars',
        type: 'TabRemittanceReport',
        props: {
          remittance: this.remittance,
          showRemovalButton: this.showRemovalButton && this.situacaoRemocaoValida
        }
      })
    },

    closeModal () {
      this.tabName = null
      this.$emit('close-modal')
    }
  }
}
</script>

<style lang='css'>
#main-value-container.main-container {
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 15px;
}

#statuses-container {
  margin-top: 10px;
}

#tab-historic-id {
  margin: 0 !important;
  padding-top: 10px;
  height: 71vh !important;
  width: 100% !important;
}

#tabbed-modal {
  min-height: 71vh !important;
}

.tab.tab-container {
  height: 100%;
}

#tab-details-id {
  position: relative;
  height: 100%;
}

#footer-monetary-container {
  bottom: 0;
  position: absolute;
  width: 100%;
}

#tab-allotment-id {
  position: relative;
  height: 100%;
}

#tab-tasks-id {
  position: relative;
  height: 100%;
}

.modal-lg {
  width: 75vw;
}

.tab-icon-font {
  font-size: 12px;
}

.tab {
  margin-top: 0px !important;
}

.tabbed-modal-body {
  padding: 0px !important;
}

#tabbed-modal.vue-tabs .nav-tabs {
  border-bottom: none;
}

#tabbed-modal.vue-tabs .nav>li.active span.title {
  color: #37F3F5;
  font-size: 12px;
}

#tabbed-modal.vue-tabs .nav>li span.title {
  color: #8AA4AF;
  font-size: 12px;
}

/*Active*/
#tabbed-modal.vue-tabs .nav-tabs>li.active>a,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus {
  border-left: 5px solid!important;
  border-color: #37F3F5!important;
  -webkit-transition: all 0.2ms!important;
  -moz-transition: all 0.2ms!important;
  -o-transition: all 0.2ms!important;
  transition: all 0.2s!important;
  border-top: 0px !important;
  border-right: 0px !important;
  border-bottom: 0px !important;
  background: #132E4D;
  color: #37F3F5!important;
}

#tabbed-modal.vue-tabs .nav-tabs>li>a,
#tabbed-modal.vue-tabs .nav-tabs>li>a:hover,
#tabbed-modal.vue-tabs .nav-tabs>li>a:focus {
  border: none !important;
  color: #8AA4AF;
  background: transparent;
  border-radius: 0px;
  margin-right: 0px;
}

#tabbed-modal.vue-tabs .nav-tabs>li>a:hover {
  background: #10253E;
}

.left-vertical-tabs {
  background: #1B3C65;
}

.modal .modal-content {
  border-left: none;
  border-bottom: none;
  border-right: none;
}

.tab-historic {
  max-height: 450px;
  overflow-y: auto;
}

.tab-left {
  text-align: center
}

#tabbed-modal.vue-tabs .nav-tabs>li.active>a>.tab-left,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover>.tab-left,
#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus>.tab-left{
  text-align: center;
  margin-left: -5px;
}
</style>



// WEBPACK FOOTER //
// RemittanceIntegrationModal.vue?260fecba